/** Undated listens are entered as a count; prevent a tiny edit expanding without bound. */
export const HISTORY_MAX_UNKNOWN_LISTENS = 10_000
export const HISTORY_EXPORT_MAX_ROWS = 100_000
